import { render, staticRenderFns } from "./AnxCheckbox.vue?vue&type=template&id=2fdb377b&scoped=true&"
import script from "./AnxCheckbox.vue?vue&type=script&lang=ts&"
export * from "./AnxCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./AnxCheckbox.vue?vue&type=style&index=0&id=2fdb377b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdb377b",
  null
  
)

export default component.exports